
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"M9.125 8.502a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0ZM15.13 8.502a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0ZM3.12 8.498a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0Z","stroke":"#798f8f","stroke-width":"1.25"}})])
          )
        }
      }
    